<cc-box>
  <div class="container-responsive" header box>
    {{ 'PLANS.PRODUCT_PLAN' | translate }}
    <span class="renewal-date" *ngIf="!isTrial">{{ 'PLANS.RENEWAL_DATE' | translate }} {{ subscription?.periodEnd | date:'M/d/yyyy' }}</span>
  </div>

  <div content box *ngIf="isTrial">
    <div class="trial-info-wrapper">
      <span *ngIf="!subscriptionExpired" class="trial-text" [innerHTML]="'NOTIFICATION.TRIAL.INFO' | translate:{time: planRemainingTime}"></span>
      <span *ngIf="subscriptionExpired" class="trial-text" [innerHTML]="'NOTIFICATION.TRIAL.EXPIRED' | translate:{time: planRemainingTime}"></span>

      <button mat-raised-button color="primary" (click)="changePlan()" >
        {{ 'NOTIFICATION.TRIAL.UPGRADE' | translate }}
      </button>
    </div>
  </div>


  <div content box *ngIf="!isTrial">
    <div class="rows">
      <div class="row">
        <div class="left">
          <div class="plan-name">{{ subscription?.licenses[0].planName }}</div>
        </div>
        <div class="right">
          <button mat-raised-button color="info-full" (click)="changePlan()">{{ 'PLANS.CHANGE' | translate }}</button>
        </div>
      </div>
      <div class="row">
        <div class="left">users</div>
        <div class="right">{{ subscription?.licenses[0].quantity }}</div>
      </div>
      <div class="row">
        <div class="left" translate>PLANS.BILLING_PERIOD</div>
        <div class="right">
          {{ (subscription?.licenses[0].interval === 'P1Y' ? 'PLANS.ANNUALLY' : 'PLANS.MONTHLY') | translate }}
        </div>
      </div>

      <div class="row" *ngIf="addonsAvailable">
        <div class="left" translate>PLANS.ADDONS</div>
        <div *ngIf="subscription?.addonLicenses?.length; else noAddons" class="right" translate>
          PLANS.UNLIMITED_CALLS
        </div>
        <ng-template #noAddons>
          <div class="right" translate>PLANS.NONE</div>
        </ng-template>
      </div>
    </div>

    <div class="row-summary">
      <div class="row">
        <div class="left" translate>PLANS.TOTAL_PRICE</div>
        <div class="right price-big">
          {{
            totalPrice | currency: (subscription?.licenses[0] ? subscription?.licenses[0].planCurrency : 'USD') :'symbol':'1.2'
          }}
        </div>
      </div>
    </div>
  </div>
</cc-box>
